import React, { FC, memo, useEffect, useState } from 'react';
import { Form, Select, Button, Input } from 'antd';
import { useTheme } from 'contexts/theme';
import { useDispatch, useSelector } from 'react-redux';
import { setFilter } from 'redux/modules/mfgLookup/slice';
import { getApp, getHistory } from 'selectors';
import Dropdown from 'components/Dropdown';

const { Item } = Form;

const ListFilterForm: FC = () => {
  const { dark } = useTheme();
  const { manufactures, distributors } = useSelector(getApp);
  const dispatch = useDispatch();

  const state = useSelector(getHistory);
  const { filter } = state;

  const onFinish = (values: any) => {
    dispatch(setFilter(values));
  };

  return (
    <Form
      name="filter-form"
      layout="horizontal"
      className={dark ? 'form-dark inline-dark' : 'form-light inline-light'}
      onFinish={onFinish}
      initialValues={{
        ...filter
      }}
    >
      <Item name="distributor" style={{ width: '200px', marginRight: "10px" }}>
        <Dropdown
          dataSource={distributors}
          valueKey='distributionName'
          allOptionName="All Distributors"
          allOptionValue="all"
          defaultValue="all"
          showSearch={true}
        />
      </Item>
      <Item name="mfg" style={{ width: '200px', marginRight: "10px" }}>
        <Dropdown
          dataSource={manufactures}
          valueKey='mfgName'
          allOptionName="All Manufactures"
          allOptionValue="all"
          defaultValue="all"
          showSearch={true}
        />
      </Item>
      <Item name="state" style={{ marginRight: "10px" }}>
        <Input placeholder="State" />
      </Item>
      <Item>
        <Button type="primary" htmlType="submit" block>
          Search
        </Button>
      </Item>
    </Form>
  );
};

export default ListFilterForm;
